import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=0c80ffe5&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"
import style0 from "./EventDetail.vue?vue&type=style&index=0&id=0c80ffe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c80ffe5",
  null
  
)

export default component.exports